var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_99",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 99",
    transform: "translate(-232 -116)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_22",
    "data-name": "\\u6955\\u5186\\u5F62 22",
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    transform: "translate(232 116)",
    fill: "#d0edff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u4EBA\\u7269\\u30A2\\u30A4\\u30B3\\u30F3_\\u30C1\\u30FC\\u30E0",
    "data-name": "\\u4EBA\\u7269\\u30A2\\u30A4\\u30B3\\u30F3\\u3000\\u30C1\\u30FC\\u30E0",
    transform: "translate(238.818 128.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_278",
    "data-name": "\\u30D1\\u30B9 278",
    d: "M9.267,163.412c0-.05-.021-.1-.021-.146v-.429a1.808,1.808,0,0,1,.1-.6,11.426,11.426,0,0,0,1.574-3.112,9.823,9.823,0,0,1-1.056-4.062,9.077,9.077,0,0,1,.059-.977,3.786,3.786,0,0,0-2.772-1.183c-2.223,0-4.026,1.814-4.026,4.632a9.538,9.538,0,0,0,1.835,4.7,1.86,1.86,0,0,1,.1.6v.429a1.369,1.369,0,0,1-.8,1.244L1.346,165.7a2.29,2.29,0,0,0-1.293,1.666l-.05.641A1.2,1.2,0,0,0,1.2,169.3H5.961l.2-2.509.013-.068a4.107,4.107,0,0,1,2.323-2.994Z",
    transform: "translate(0.001 -149.463)",
    fill: "#1873b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_279",
    "data-name": "\\u30D1\\u30B9 279",
    d: "M348.983,167.367a2.287,2.287,0,0,0-1.292-1.666l-2.916-1.19a1.367,1.367,0,0,1-.8-1.244v-.429a1.808,1.808,0,0,1,.1-.6,9.54,9.54,0,0,0,1.834-4.7c0-2.818-1.8-4.632-4.029-4.632a3.787,3.787,0,0,0-2.772,1.185,8.769,8.769,0,0,1,.06.975,9.837,9.837,0,0,1-1.054,4.061,11.4,11.4,0,0,0,1.575,3.113,1.861,1.861,0,0,1,.1.6v.429c0,.05-.017.1-.022.146l.722.294a4.131,4.131,0,0,1,2.377,3.014l.012.069.194,2.51h4.764a1.2,1.2,0,0,0,1.2-1.291Z",
    transform: "translate(-316.881 -149.463)",
    fill: "#1873b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_280",
    "data-name": "\\u30D1\\u30B9 280",
    d: "M132.119,113.561l-3.527-1.442a1.658,1.658,0,0,1-.965-1.505v-.52a2.183,2.183,0,0,1,.121-.722s2.218-2.96,2.218-5.69c0-3.411-2.181-5.6-4.873-5.6s-4.873,2.193-4.873,5.6c0,2.73,2.22,5.69,2.22,5.69a2.235,2.235,0,0,1,.121.722v.52a1.661,1.661,0,0,1-.967,1.505l-3.527,1.442a2.761,2.761,0,0,0-1.564,2.017l-.182,2.337h17.544l-.18-2.337A2.768,2.768,0,0,0,132.119,113.561Z",
    transform: "translate(-109.015 -98.078)",
    fill: "#1873b6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard1);
export default __webpack_public_path__ + "static/media/dashboard-1.90501d96f06e91e409032593ef3c300b.svg";
export { ForwardRef as ReactComponent };